/**
 * Reusable Zod schema helpers for trimming and normalizing strings.
 */

import { z } from 'zod';

function trimAndEmptyToUndefined(val: unknown): unknown {
  if (val == null) return undefined;
  if (typeof val !== 'string') {
    return val; // pass through to trigger Zod type error
  }
  const trimmed = val.trim();
  return trimmed === '' ? undefined : trimmed;
}

/**
 * Required string: trims and treats empty string as undefined (fails required).
 */
export const nonEmptyString = z.preprocess(
  val => trimAndEmptyToUndefined(val),
  z.string()
);

/**
 * Optional string: trims and normalizes empty string to undefined.
 */
export const nonEmptyOptionalString = z.preprocess(
  val => trimAndEmptyToUndefined(val),
  z.string().optional()
);
